<template>
  <div :class="['file-header', 'nav-bar-bgcolor', scenario === 'fileSelect' && 'file-select-header', isExternalShare && 'exteranl-share']">
    <div class="back-nav" v-if="showBack" @click="back()">
      <i v-if="this.space !== 'frequent' && !openViewTitle" class="iconfont icon-back"/>
      <span class="pre-ellipsis" v-if="backToParent">{{backToParent.name}}</span>
    </div>
    <div class="name" @click="toggleNav">
      <span v-if="openViewTitle" class="open-title"><span class="ellipsis">{{productName}}</span><span>{{productName ? '-' : ''}}{{openViewTitle}}</span></span>
      <span v-else class="pre-ellipsis">{{listError ? $t('base.error') : item.name}}</span>
      <i v-if="!disableGoto && !openViewTitle" :class="['iconfont', 'icon-arrow-down', showNav && 'rotate-up']"/>
    </div>
    <div class="action" v-if="!listError && showAction">
      <template v-if="!isExternalShare">
        <i
          v-if="space !== 'frequent'"
          :class="['iconfont', item.is_frequently_used ? 'icon-star' : 'icon-unstar']"
          @click="toggleFrequent"
        />
        <router-link v-else class="msg-icon-box" to="/message">
          <i class="iconfont icon-news"></i>
          <badge v-if="unreadMessageCount != 0" :content="unreadMessageCount" />
        </router-link>
      </template>
      <i
        class="iconfont icon-more"
        v-if="space === 'folder' || space === 'file'"
        @click="onMenuClick"
      />
    </div>
    <div class="action cancel" v-if="scenario === 'fileSelect' || $route.name === 'OpenView'" @click="cancelSelect">{{ $t('base.cancel') }}</div>
  </div>
</template>
<script>
import config from '@/config'
import {i18n} from '@/utils/i18n'
import ajax from '@/utils/ajax'
import fileActions from '@/utils/fileActions'
import { normalizeFile, getParentItem } from '@/utils/fileUtils'
import {FILE_INFO, DEPARTMENT_INFO} from '@/config/api'
import Badge from '../utils/Badge'

const spaceNames = {
  own: i18n.t('file.personalFiles'),
  collab: i18n.t('file.collabWithMe'),
  frequent: i18n.t('file.frequent'),
  trash: i18n.t('file.trash')
}

export default {
  name: 'FileHeader',
  i18n,
  components: {
    Badge
  },
  props: {
    headerName: String,
    scenario: {
      type: String,
      default: 'fileView'
    },
    isDeleted: Boolean,
    isFrequent: Boolean,
    spaceClosed: Boolean,
    listError: Boolean,
    isOpenIndex: {
      type: Boolean,
      default: false
    },
    isExternalShare: Boolean
  },
  data () {
    return {
      space: null,
      item: {
        name: this.headerName
      },
      historyState: window.history.state
    }
  },
  computed: {
    showNav () {
      return !!this.$route.query[this.scenario === 'fileSelect' ? 'selectnav' : 'filenav']
    },
    showAction () {
      return (this.scenario === 'fileView' && this.$route.name !== 'OpenView' && !['trash'].includes(this.space)) || this.isExternalShare
    },
    showBack () {
      return (this.scenario === 'fileSelect' && this.backToParent) || (this.scenario !== 'fileSelect' && this.historyState !== null)
    },
    backToParent () {
      if (this.scenario !== 'fileSelect' || ['own', 'collab', 'external'].includes(this.space)) {
        return null
      }
      return getParentItem(this.item)
    },
    unreadMessageCount () {
      return config.unread_messages_count || 0
    },
    disableGoto () {
      return this.listError || this.scenario === 'share' || this.$route.query.from_message || this.isExternalShare
    },
    openViewTitle () {
      const { params: {module, space, id} } = this.$route
      const titleMessages = {
        select_files: i18n.t('open.selectFiles'),
        select_destination: i18n.t('open.selectDestination')
      }
      return !space && !id && titleMessages[module]
    },
    productName () {
      return config.openConfig.productName
    }
  },
  watch: {
    $route (to, from) {
      /* eslint-disable eqeqeq */
      if (from.params.space !== to.params.space || from.params.id != to.params.id || from.query.folder_id != to.query.folder_id) {
        this.getInfo()
      }
      /* eslint-enable eqeqeq */
      this.historyState = window.history.state
    },
    'selectListStack' (stack) {
      if (this.scenario === 'fileSelect' && stack.length) {
        this.getInfo()
      }
    },
    'store.actionState' (state) {
      const { action, type, id, name, is_frequently_used } = state
      if (this.item.typed_id !== `${type}_${id}`) return

      switch (action) {
        case 'rename':
          this.item.name = name
          break

        case 'delete':
          if (this.historyState) {
            this.back()
          } else {
            this.$router.replace('/')
            window.history.replaceState(null, null, null)
          }
          break

        case 'frequent':
          this.item.is_frequently_used = is_frequently_used
          normalizeFile(this.item)
          break

        default:
          break
      }
    },
    headerName (name) {
      this.item.name = name
    },
    isFrequent (isFrequent) {
      if (this.space === 'external') {
        this.item.is_frequently_used = isFrequent
      }
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      const params = this.selectListPeek

      let { space, id } = params || this.$route.params
      if (this.isExternalShare) {
        space = 'folder'
        id = this.$route.query.folder_id
      }

      this.space = space
      let url, data

      switch (space) {
        case 'own':
        case 'collab':
        case 'frequent':
        case 'trash':
          this.item = {
            name: spaceNames[space],
            typed_id: `${space}_0`,
            is_frequently_used: config.frequent_space[`has_${space}`]
          }
          break

        case 'folder':
          url = `${FILE_INFO}?item_typed_id=folder_${id}`
          if (this.scenario === 'share') {
            url += '&scenario=share'
          }
          break

        case 'dept':
          url = DEPARTMENT_INFO
          data = {
            department_id: id
          }
          break

        case 'external':
          this.item = {
            ...this.item,
            typed_id: id,
            is_frequently_used: this.isFrequent
          }
          break

        default:
          break
      }

      if (url) {
        ajax({url, data}).then(result => {
          if (result && result.success) {
            // 校验route
            const item = result.item || result.department
            /* eslint-disable eqeqeq */
            if (item.id != (this.scenario !== 'fileSelect' ? this.$route.params.id : this.selectListPeek.id) && item.id != this.$route.query.folder_id) {
              return
            }
            /* eslint-enable eqeqeq */
            if (result.department) {
              item.isDepartment = true
              item.typed_id = `department_${item.id}`
            }
            normalizeFile(item)
            this.item = item
            this.$emit('item-change', this.item)
          }
        })
      } else {
        this.$emit('item-change', this.item)
      }
    },
    toggleNav () {
      const query = this.scenario === 'fileSelect' ? 'selectnav' : 'filenav'
      // 分享没有下拉菜单
      if (this.disableGoto) {
        return false
      } else {
        this.toggleQuery(query)
      }
    },
    back () {
      if (this.scenario === 'fileSelect') {
        this.selectListStack.push(this.backToParent)
      } else {
        this.$router.go(-1)
      }
    },
    toggleFrequent () {
      fileActions.handleAction(this.item.is_frequently_used ? 'unfrequent' : 'frequent', this.item, 'header')
    },
    onMenuClick () {
      this.setState({actionSheet: {
        actionItem: this.item,
        actionFrom: this.isExternalShare ? 'share' : 'header'
      }})
    },
    cancelSelect () {
      if (this.showNav && !this.isOpenIndex) {
        this.toggleNav()
      } else {
        this.$emit('close-select')
      }
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.file-header {
  color: #fff;
  font-size: 18px;
  height: 44px;
  line-height: 44px;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;

  &::after {
    border: 0
  }

  &.exteranl-share {
    background-color: #fff;
    color: #000
  }

  & .name {
    display: flex;
    justify-content: center;
    padding: 0 80px;

    & span {
      overflow: hidden;
    }

    & .icon-arrow-down {
      font-size: 18px;
      margin-left: 2px;
    }

    & .open-title {
      display: flex;

      & span {
        flex: 1 0 auto;
      }

      & .ellipsis {
        flex: 0 1 auto;
      }
    }
  }

  & .back-nav {
    position: absolute;
    left: 0;
    padding: 0 10px;
    font-size: 16px;

    & .iconfont {
      float: left;
    }
    & span {
      float: left;
      width: 70px;
    }
  }

  & .iconfont {
    font-size: 20px;
  }

  & .icon-star {
    color: #ffb743
  }

  & .icon-more {
    margin-left: 8px;
  }

  & .action {
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    padding: 0 10px;
  }

  & .msg-icon-box {
    position: relative;
    height: 22px;
    margin-right: 4px;
    color: #fff
  }

  & .action.cancel {
    font-size: 16px;
  }
}

.file-select-header .name {
    padding: 0 110px;
}
</style>
